import { Cancel } from '@mui/icons-material';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';

import Dropdown from './Dropdown';
import { DropdownProps, MultiSelectProps } from './Dropdown.types';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function MultipleSelectChip({
  onChange,
  value,
  options = [],
  ...rest
}: MultiSelectProps) {
  const handleChange: DropdownProps['onChange'] = (val) => {
    // On autofill we get a stringified val.
    if (val) onChange?.(typeof val === 'string' ? [...val.split(',')] : val);
    else onChange?.([]);
  };
  const handleDelete = (val: DropdownProps['value']) => {
    onChange?.(value?.filter((d) => d !== val) || []);
  };

  return (
    <Dropdown
      multiple
      value={value || []}
      onChange={handleChange}
      renderValue={(selected: typeof value) => (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
          {selected?.map?.((value) => (
            <Chip
              deleteIcon={
                <Cancel onMouseDown={(event) => event.stopPropagation()} />
              }
              onDelete={(e) => {
                e.stopPropagation();
                handleDelete(value);
              }}
              size="small"
              key={value}
              label={options?.find((d) => d.id === value)?.name || value}
            />
          ))}
        </Box>
      )}
      MenuProps={MenuProps}
      options={options || []}
      name="multi-select-chip"
      {...rest}
    />
  );
}
